import Widget from "csi/form/Widget";
import declare from "dojo/_base/declare";
import xml from "csi/xml";
import { Field } from "csi/def/Field";

const NewAffectedSpecsForm = declare(Widget, {

	/**
     * @override
     * override and replace the field m_type from Refset to Ref
     */
	_resolveView() {
		this.inherited(arguments);

		const field: Field = this.defView.getField("AffectedItems");

		field.m_type = xml.ATTR_REF;
	},

});

export = NewAffectedSpecsForm;